import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "id", "className", "isFullHeight", "isFullWidth", "canOutsideClickClose", "canEscapeKeyClose", "isOpen", "mode", "onClose", "portalContainer", "usePortal", "variant", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Modal.styles';
import ModalHeader from './components/Header';
import ModalAlert from './components/Alert';
import { ModalTabs, ModalTabList, ModalTab, ModalTabPanels, ModalTabPanel } from './components/Tabs';
import ModalBody from './components/Body';
import ModalFooter from './components/Footer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModalContext = createContext();
var Modal = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      id = _ref.id,
      customClassName = _ref.className,
      _ref$isFullHeight = _ref.isFullHeight,
      isFullHeight = _ref$isFullHeight === void 0 ? false : _ref$isFullHeight,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      _ref$canOutsideClickC = _ref.canOutsideClickClose,
      canOutsideClickClose = _ref$canOutsideClickC === void 0 ? true : _ref$canOutsideClickC,
      _ref$canEscapeKeyClos = _ref.canEscapeKeyClose,
      canEscapeKeyClose = _ref$canEscapeKeyClos === void 0 ? true : _ref$canEscapeKeyClos,
      isOpen = _ref.isOpen,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      onClose = _ref.onClose,
      portalContainer = _ref.portalContainer,
      _ref$usePortal = _ref.usePortal,
      usePortal = _ref$usePortal === void 0 ? true : _ref$usePortal,
      variant = _ref.variant,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-modal"), true), _defineProperty(_cx, "".concat(prefix, "-modal--fullheight"), isFullHeight), _defineProperty(_cx, "".concat(prefix, "-modal--fullwidth"), isFullWidth), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode
    },
    children: _jsxs(ModalContext.Provider, {
      value: {
        onClose: onClose,
        variant: variant
      },
      children: [_jsx(Styled.BPDialogStyles, {}), _jsx(Styled.Modal, _objectSpread(_objectSpread({
        ref: ref,
        id: id,
        className: className,
        canOutsideClickClose: canOutsideClickClose,
        isOpen: isOpen,
        width: width,
        onClose: onClose,
        portalContainer: portalContainer || document.body,
        usePortal: usePortal
      }, rest), {}, {
        children: children
      }))]
    })
  });
});
Modal.Header = ModalHeader;
Modal.Alert = ModalAlert;
Modal.Tabs = ModalTabs;
Modal.TabList = ModalTabList;
Modal.Tab = ModalTab;
Modal.TabPanels = ModalTabPanels;
Modal.TabPanel = ModalTabPanel;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
export default Modal;